<template>
    <v-content>
        <v-row class="pb-0 pb-sm-2">
            <v-col class="display-1">
                Список телефонов
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="info" depressed @click="updatePhones()">
                        Обновить список телефонов
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-select
                  outlined
                  dense
                  hide-details
                  clearable
                  :items="mailing_accounts"
                  item-value="id"
                  item-text="name"
                  label="Аккаунт рассыльщика"
                  v-model="mailing_account_id"
                  @input="getOutgoingPhones"
                />
            </v-col>
        </v-row>
        <b-table
            :data="outgoing_phones.results"
            :loading="isLoading"
            paginated
            backend-pagination
            :total="outgoing_phones.total"
            :per-page="perPage.value"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
        >
            <template slot-scope="props">
                <b-table-column field="id" label="ID" numeric sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="name" label="Название" sortable>
                    {{ props.row.phone }}
                </b-table-column>

                <b-table-column field="name" label="Аккаунт">
                    {{ props.row.account_mailer.name }}
                </b-table-column>

                <b-table-column field="type" label="Тип">
                    {{ props.row.type }}
                </b-table-column>
            </template>
            <template slot="bottom-left">
                <div class="pagination-controls">
                  <v-select
                    style="width: fit-content; float: left;"
                    v-model="perPage.value"
                    @change="getOutgoingPhones"
                    :items="perPageOptions"
                    item-text="name"
                    item-value="value"
                    outlined
                    hide-details
                    dense
                  />
                </div>
            </template>
        </b-table>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: 'OutgoingPhonesList',
    components: {
        OverlayLoader,
    },
    data() {
        return {
            sortField: "id",
            sortOrder: "desc",
            page: 1,
            perPage: {
                value: 20,
            },
            mailing_account_id: null,
            perPageOptions: [
                { name: "10 на странице", value: 10 },
                { name: "20 на странице", value: 20 },
                { name: "50 на странице", value: 50 },
                { name: "100 на странице", value: 100 },
            ],
        };
    },
    created() {
        this.getOutgoingPhones();
        this.$store.dispatch('GET_MAILING_ACCOUNT_LIST', { type_of_notification: 'call' });
    },
    computed: {
        outgoing_phones() {
            return this.$store.getters.OUTGOING_PHONES_LIST;
        },
        mailing_accounts() {
            return this.$store.getters.MAILING_ACCOUNTS_LIST.results;
        },
        isLoading() {
            return this.$store.getters.OUTGOING_PHONES_LOADING;
        },
    },
    methods: {
        getOutgoingPhones() {
            const params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                mailing_account: this.mailing_account_id,
            };
            this.$store.dispatch('GET_OUTGOING_PHONES_LIST', params);
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.getOutgoingPhones();
        },
        onPageChange(page) {
            this.page = page;
            this.getOutgoingPhones();
        },
        updatePhones() {
            this.$store
                .dispatch("UPDATE_OUTGOING_PHONES")
                .then(() => {
                    this.getOutgoingPhones();
                    this.$toast.success("Номера телефонов обновлены!");
                })
                .catch(() => {
                    this.$toast.error("Неизвестная ошибка!");
                });
        }
    }
}
</script>

<style>

</style>
